export const getEmptyConducteurForm = () => ({
    personneId: 0,
    codeId: "",
    nom: "",
    prenom: "",
    genre: "MASCULIN",
    profession: "",
    email: "",
    adresse: "",
    telephone: "",
    contact: [],
    pieces: [],
    typePiece: null,
    numIdentite: "",
    lieuDelivrance: "",
    dateDelivrance: "",
    dateNaissance: "",
});

// Fonction pour formater la CNI
export const formatCNI = (value) => {
    if (!value) return value;
    value = value.replace(/-/g, "");
    if (value.length > 4 && value.length <= 7) {
        value = value.slice(0, 4) + "-" + value.slice(4);
    } else if (value.length > 7) {
        value = value.slice(0, 4) + "-" + value.slice(4, 7) + "-" + value.slice(7, 11);
    }
    return value;
};